/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", async function () {
    const input = document.getElementById("delivery-date");
    if (!input) return;

    // Get timezone of store (set in window.shopData)
    const storeTimezone = window.shopData?.timezone || "Europe/Paris";
    const now = new Date();
    const storeTime = new Date(now.toLocaleString("en-US", { timeZone: storeTimezone }));
    const currentHour = storeTime.getHours();

    // Calculate earliest delivery date:
    const minDate = new Date(storeTime);
    minDate.setDate(minDate.getDate() + (currentHour < 11 ? 1 : 2));

    // Public holidays from metaobject
    let holidayDates = Array.isArray(window.publicHolidays) ? window.publicHolidays : [];

    // Lấy label từ settings
    const label = window.shopSettings?.delivery_date_label || "Preferred Delivery Date";

    // Disable weekends and public holidays
    const disableDays = [
      function (date) {
        const day = date.getDay();
        return day === 0 || day === 6; // 0 = Sunday, 6 = Saturday
      },
      ...holidayDates
    ];

    // --- Helper: update attribute
    async function updateCartAttribute(dateStr) {
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              [label]: dateStr
            },
          }),
        });
      } catch (err) {
        /* delivery date update failed — silent */
      }
    }

    // --- Check cart & auto-add
    try {
      const cartResp = await fetch("/cart.js");
      const cartData = await cartResp.json();
      const savedDate = cartData.attributes?.[label];
      const defaultDateStr = minDate.toISOString().split("T")[0];

      if (!savedDate) {
        await updateCartAttribute(defaultDateStr);
        input.value = defaultDateStr;
      } else {
        input.value = savedDate;
      }
    } catch (e) {
      /* cart load failed — silent */
    }

    // Initialize Flatpickr
    const calendar = flatpickr(input, {
      locale: flatpickr.l10ns.fr,
      dateFormat: "Y-m-d",
      minDate: minDate,
      defaultDate: input.value || minDate,
      disable: disableDays,
      onReady: function (selectedDates, dateStr, instance) {
        instance.jumpToDate(minDate);
      },
      onChange: async function (selectedDates, dateStr) {
        if (!dateStr) return;
        await updateCartAttribute(dateStr);
      },
    });

    // Sync with Cart Drawer (dynamic re-render)
    const observer = new MutationObserver(() => {
      const drawerInput = document.querySelector("#delivery-date");
      if (drawerInput && !drawerInput._flatpickr) {
        flatpickr(drawerInput, {
          locale: flatpickr.l10ns.fr,
          dateFormat: "Y-m-d",
          minDate: minDate,
          disable: disableDays,
          defaultDate: input.value || minDate,
          onChange: async function (selectedDates, dateStr) {
            if (!dateStr) return;
            await updateCartAttribute(dateStr);
          },
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // ── Delivery address auto-save to cart attribute ──────────────
  (function initDeliveryAddress() {
    const ATTR_KEY = "Adresse de livraison souhait\u00e9e";
    let saveTimer = null;

    function bindDeliveryAddress() {
      document.querySelectorAll('[data-delivery-address]').forEach(function (ta) {
        if (ta._deliveryAddrBound) return;
        ta._deliveryAddrBound = true;

        ta.addEventListener('change', debouncedSave);
        ta.addEventListener('blur', debouncedSave);
      });
    }

    function debouncedSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        var ta = document.querySelector('[data-delivery-address]');
        if (!ta) return;
        var val = ta.value.trim();
        var attrs = {};
        attrs[ATTR_KEY] = val;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).catch(function () { /* silent */ });
      }, 500);
    }

    // Bind on load + observe for drawer re-renders
    bindDeliveryAddress();
    var observer = new MutationObserver(bindDeliveryAddress);
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  /**
   * Clears the cart in Shopify and logs the result or errors.
   */
  function clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        updateCartUI();
      })
      .catch(error => {
        handleCartError(error);
      });
  }

  // Example usage: Clear the cart when the DOM content is loaded
  if (document.querySelector('.js-btn-logout')) {
    document.querySelector('.js-btn-logout').addEventListener('click', () => {
      clearCart();
      setTimeout(function () {
        window.location.pathname = '/account/logout';
      }, 2000);
    });
  }
})();

// Remove "à partir de" / "From" text on product cards
document.addEventListener('DOMContentLoaded', function() {
  function removeFromText() {
    document.querySelectorAll('.new-price small, .price small').forEach(el => el.remove());
  }
  
  removeFromText();
  
  // Observer for dynamic content (Globo filters, infinite scroll, etc.)
  const observer = new MutationObserver(removeFromText);
  observer.observe(document.body, { childList: true, subtree: true });
});
